import React, { useState, useMemo, useRef, useEffect, useCallback } from "react";
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogActions,
  Button,
} from "@fluentui/react-components";
import "./style.css";
import DOMPurify from "dompurify";

const ReactQuillComponent = ({ value, width }: any) => {
  const [open, setOpen] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const previewRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLSpanElement>(null);
  const scrollPosRef = useRef<{ x: number; y: number }>({ x: 0, y: 0 });

  const cleanedText = useMemo(() => DOMPurify.sanitize(value), [value]);

  useEffect(() => {
    const el = previewRef.current;
    if (el) {
      setIsOverflowing(el.scrollHeight > el.clientHeight + 1);
    }
  }, [cleanedText]);

  const handleOpen = useCallback(() => {
    scrollPosRef.current = { x: window.scrollX, y: window.scrollY };
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
    requestAnimationFrame(() => {
      window.scrollTo(scrollPosRef.current.x, scrollPosRef.current.y);
      triggerRef.current?.focus({ preventScroll: true });
    });
  }, []);

  const handleOpenChange = useCallback(
    (_: any, data: { open: boolean }) => {
      if (!data.open) {
        // Only restore scroll when dismissed via outside click / Escape,
        // NOT via the Close button (which already calls handleClose directly)
        setOpen(false);
      }
    },
    []
  );

  return (
    <>
      <div className="note-preview-wrapper">
        <div
          ref={previewRef}
          style={{ width: width ? width : "300px" }}
          className="note_lineClamp"
        >
          <div dangerouslySetInnerHTML={{ __html: cleanedText }} />
        </div>

        {isOverflowing && (
          <span
            ref={triggerRef}
            className="view-more-link"
            onClick={handleOpen}
          >
            View more
          </span>
        )}
      </div>

      <Dialog open={open} onOpenChange={handleOpenChange} modalType="non-modal">
        <DialogSurface style={{ minHeight: "fit-content" }}>
          <DialogBody style={{ display: "flex", flexDirection: "column" }}>
            <div className="dialog_content">
              <div dangerouslySetInnerHTML={{ __html: cleanedText }} />
            </div>
          </DialogBody>

          <DialogActions>
            <Button appearance="secondary" onClick={handleClose}>
              Close
            </Button>
          </DialogActions>
        </DialogSurface>
      </Dialog>
    </>
  );
};

export default ReactQuillComponent;